import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api/api.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';

@Component({
  selector: 'app-role-modal',
  templateUrl: './role-modal.component.html',
  styleUrl: './role-modal.component.css',
  standalone: false
})
export class RoleModalComponent implements OnInit{
  roleManagementForm!: FormGroup;
  isLoadingPrivileges: boolean = true;
  isSubmitting: boolean = false;
  isSubmitAttempted: boolean = false;
  privileges: any[] = [];
  isLoading: boolean = false;

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<RoleModalComponent>,
    @Inject(MAT_DIALOG_DATA) public editModeData: any,
    private apiService: ApiService
  ) {}

  ngOnInit(): void {
    this.initForm();

    this.getAllPrivileges();
  }

  initForm(): void {
    this.roleManagementForm = this.fb.group({
      name:  ['', [Validators.required, Validators.maxLength(40)]],
      description:  ['', [Validators.required, Validators.maxLength(100)]],
      privileges: [[], Validators.required],
    });
  }

  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      location.reload()
    });
  }


  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {

    });
  }


  openConfirmModal() {

        this.dialog.open(ConfirmActionComponent, {
          width: '400px',
          backdropClass: 'modal-form-backdrop',
          hasBackdrop: true,
          panelClass: ['modal-form', 'modal-no-overflow-changed'],
          disableClose: true,

          data: {
            title: "Confirm role creation?",
            body: '',
            confirmText: 'Yes',
            lottieIconPath: 'assets/lottie/alert.json',
            onConfirm: () => {

              this.saveRole()
            },
            onCancel: () => {

            },
            showCancelButton: true,
            showConfirmButton: true,
          },
        });

  }


  getAllPrivileges() {
    this.isLoading = true;
    this.apiService
      .get('/privileges/all')
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {
        this.privileges = response.data
      });
  }


  toggleSelection(item: any, selected: boolean, event: Event) {
    event.stopPropagation();

    setTimeout(() => {
      const control = this.roleManagementForm.get('privileges');
      let selectedValues = [...(control?.value || [])];

      if (selected) {

        selectedValues = selectedValues.filter((id: any) => id !== item.privilegeId);
      } else {

        selectedValues.push(item.privilegeId);
      }

      control?.setValue(selectedValues);
      control?.updateValueAndValidity();
    });
  }

  isSelected(item: any): boolean {
    const selectedValues = this.roleManagementForm.get('privileges')?.value || [];
    return selectedValues.includes(item.privilegeId);
  }


  toTitleCase(str: string): string {
    return str
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }

  selectAll(ngSelect: NgSelectComponent, controlName: string) {
    const control = this.roleManagementForm.get(controlName);
    if (control) {
      control.setValue(this.privileges.map(p => p.privilegeId));
      control.markAsDirty();
      ngSelect.close();
    }
  }

  closeModal(): void {
    this.roleManagementForm.reset();
    this.dialogRef.close();
  }


  saveRole(): void {
    this.isSubmitAttempted = true;

    if (this.roleManagementForm.valid) {
      const formData = this.roleManagementForm.value;

      const roleRequest = {
        name: formData.name,
        description: formData.description,
        privilegeIds: formData.privileges,
        lga: 759
      };

      this.isSubmitting = true;

      const url = '/roles/create'

      this.apiService
      .post(url, roleRequest)
      .pipe(finalize(() => (this.isSubmitting = false)))
      .subscribe(
        () => {
          this.openSuccessModal('Role saved successfully');

        },
        (error) => {
          this.openErrorModal(error?.message)
        }
      );
    }
  }


}
